import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const WaypointCard = ({waypoint}) => {
    return (
        <div className="row card-waypoint">
                <div className="col card-waypoint-icon">
                    <FontAwesomeIcon icon={waypoint.icon} className="text-secondary"/>
                </div>
                <div className="col card-waypoint-info">
                    <div className="small text-muted">{waypoint.name}</div>
                    <div>{waypoint.full_address}</div>
                </div>
        </div>
    )
}
export default WaypointCard;